import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { EventType } from './EventType';

export interface EventProps {
  object_id: string;
  type: EventType;
  data?: any;
  meta: any;
  created_by: string;
  created_at: Date;
}

export class Event extends ValueObject<EventProps> {
  get created_at(): Date {
    return this.props.created_at;
  }
  get created_by(): string {
    return this.props.created_by;
  }
  get object_id(): string {
    return this.props.object_id;
  }
  get data(): any {
    return this.props.data;
  }
  get type(): EventType {
    return this.props.type;
  }
  set type(type: EventType) {
    this.props.type = type;
  }
  get meta(): any {
    return this.props.meta;
  }

  private constructor(props: EventProps) {
    super(props);
  }

  static create(props: EventProps) {
    return new Event(props);
  }
}
